<template>
  <div id="Completed">Completed View</div>
</template>

<script>
export default {
    name: 'Completed',
    components: {},
    data: () => ({}),
    computed: {},
    methods: {},
    mounted() {}
};
</script>
